// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.renderInput[data-v-6bd270a6] {\n  width: 120px;\n  margin: 0 5px 10px;\n  display: inline-block;\n}\n.renderSelect[data-v-6bd270a6] {\n  width: 120px;\n  margin: 0 5px 10px;\n  display: inline-block;\n}\n", ""]);
// Exports
module.exports = exports;
